import { Drawer, drawerClasses } from '@mui/material';
import styled from '@mui/material/styles/styled';
var FbmDrawerRoot = styled(Drawer)(function (_a) {
    var _b;
    var zIndex = _a.zIndex;
    return _b = {
            zIndex: zIndex
        },
        _b["& ." + drawerClasses.paperAnchorRight] = {
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
        },
        _b;
});
FbmDrawerRoot.defaultProps = {
    zIndex: 1300,
    anchor: 'right'
};
export default FbmDrawerRoot;
